import { render, staticRenderFns } from "./orden.vue?vue&type=template&id=f51c7f7a&scoped=true&"
import script from "./orden.vue?vue&type=script&lang=js&"
export * from "./orden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51c7f7a",
  null
  
)

export default component.exports

/* vue-automatic-import-loader */
import autoInstallComponents from "!/Users/waltergammarota/Documents/Trabajo/Orsai/casciari-admin/node_modules/vue-automatic-import-loader/lib/runtime/autoInstallComponents.js"
import WTopBar from '@/components/WTopBar.vue'
autoInstallComponents(component, {WTopBar})
